var __TEMP__ = require('./_baseCreate.js');var baseCreate = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getPrototype.js');var getPrototype = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isPrototype.js');var isPrototype = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = initCloneObject;
